<template>
  <div>
    <quick-link v-for="link in quickLinks"
                :label="link.label"
                :route="link.url"
                :icon="link.icon"
    />
  </div>
</template>

<script>
import QuickLink from '@/components/Dashboard/QuickLink';

export default {
  name: "ActionQuicklinks",
  components: {
    QuickLink,
  },
  computed: {
    quickLinks() {
      const user = this.$store.getters.authUser;
      const { teams } = user;

      if (teams && teams.length) {
        return [{
          label: 'Team Management',
          url: 'team-management',
          icon: 'teammanager',
        }];
      }

      return [{
        label: 'Action List',
        url: 'actions',
        icon: 'clientactions',
      }];

    },
  },
}
</script>

<style scoped>

</style>
